import { Module } from '../Module';

Module.instance().directive('tbTooltipArea', <any[]>[
  '$parse',
  ($parse: ng.IParseService) => {
    return {
      link: (scope: ng.IScope, element: JQuery, attr: ng.IAttributes) => {
        const offset = 10;
        const textFn = $parse(attr['tbTooltipArea']);

        const eventNamespace = '.tbTooltipArea';
        let origin: JQueryCoordinates;
        let tooltip: JQuery;

        const updateTooltip = (mouseEvent: JQuery.Event) => {
          const tooltipText = textFn(scope, { $event: mouseEvent });
          if (tooltipText) {
            tooltip.text(tooltipText);
            let left = mouseEvent.pageX - origin.left + offset;
            let top = mouseEvent.pageY - origin.top + offset;
            tooltip.css({
              display: 'block',
              left: left,
              top: top
            });
            const tooltipWidth = tooltip.outerWidth();
            const tooltipHeight = tooltip.outerHeight();
            const containerWidth = element.width();
            const containerHeight = element.height();
            const maxLeft = containerWidth - tooltipWidth;
            const maxTop = containerHeight - tooltipHeight;
            if (left > maxLeft) {
              left = maxLeft;
              tooltip.css('left', left);
            }
            if (top > maxTop) {
              top -= tooltipHeight + offset*2;
              tooltip.css('top', top);
            }
          } else {
            tooltip.css('display', 'none');
          }
        };

        element.on('mouseenter' + eventNamespace, (enterEvent: JQuery.Event) => {
          origin = element.offset();
          if (tooltip) {
            tooltip.remove();
          }
          tooltip = $('<div>').addClass('tb-tooltip').appendTo(element);
          updateTooltip(enterEvent);

          element.on('mousemove' + eventNamespace, (moveEvent: JQuery.Event) => {
            updateTooltip(moveEvent);
          });
        });
        element.on('mouseleave' + eventNamespace, (leaveEvent: JQuery.Event) => {
          element.off('mousemove' + eventNamespace);

          tooltip.remove();
          tooltip = null;
        });

        scope.$on('$destroy', () => {
          if (tooltip) {
            tooltip.remove();
            tooltip = null;
          }
          element.off(eventNamespace);
        });

      }
    };
  }
]);

